import type React from "react";
import { useState } from "react";
import "./PhoneNumberForm.css";
import "react-international-phone/style.css";
import { cn } from "@/lib/utils";
import { formClassNames } from "@/shared/constants/customStyleSets";
import { ConfirmPhone } from "./components/ConfirmPhone";
import { EnterPhone } from "./components/EnterPhone";

type Props = {
	onSuccess: () => void;
	onClose: (phone?: string) => void;
	className?: string;
	showTitle?: boolean;
};

export const PhoneNumberForm: React.FC<Props> = ({
	onSuccess,
	onClose,
	className,
	showTitle = true,
}) => {
	const [phone, setPhone] = useState("");
	const [formName, setFormName] = useState<"phone" | "confirm">("phone");

	return (
		<div
			data-testid="phone-number-form"
			className={cn(formClassNames, className)}
			onClick={(e) => e.stopPropagation()}
			onKeyDown={(e) => e.stopPropagation()}
		>
			{formName === "phone" ? (
				<EnterPhone
					setFormName={setFormName}
					phone={phone}
					setPhone={setPhone}
					showTitle={showTitle}
					className="border-none"
				/>
			) : (
				<ConfirmPhone
					phone={phone}
					setFormName={setFormName}
					onClose={() => onClose(phone)}
					onSuccess={onSuccess}
					showTitle={showTitle}
					className="border-none md:p-0"
				/>
			)}
		</div>
	);
};
